import { Injectable } from '@angular/core';
import { ASSET_TYPES_STORE, ISSUE_CFGS_STORE } from '@damofire/data-commons';
import { TranslateService } from '@ngx-translate/core';
import { AssetTypeDescEnum } from '../asset/asset.dto';
import { LockingIndexedService } from '../indexed/locking-indexed.service';
import { AssetTypeCfg, IssueCfg } from '../issue/issue.dto';
import { IssueCfgService } from './issue-cfg.service';

@Injectable()
export class IdbIssueCfgService extends IssueCfgService {
  constructor(
    private readonly idbService: LockingIndexedService,
    protected readonly translateService: TranslateService,
  ) {
    super(translateService);
  }

  getAssetsConfiguration(divisionId: string, organizationId: string, assetType = AssetTypeDescEnum.PALLET_RACK): Promise<AssetTypeCfg> {
    return this.idbService.getByKey(divisionId, ASSET_TYPES_STORE, assetType);
  }

  getIssuesConfiguration(divisionId: string, organizationId: string): Promise<IssueCfg> {
    return this.idbService.getByKey(divisionId, ISSUE_CFGS_STORE, 'default');
  }
}
